import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform } from '@ionic/angular/standalone';
import { ToastrService } from '../toastr/toastr.service';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Injectable({
  providedIn: 'root',
})
export class NavService {
  private lastTimeBackPress = 0;
  private timePeriodToExit = 2000;

  private readonly _nav = inject(NavController);
  private readonly _router = inject(Router);
  private readonly _toast = inject(ToastrService);
  private readonly _platform = inject(Platform);

  constructor() {
    this.iniciarBackButton();
  }

  iniciarBackButton() {
    App.addListener('backButton', async () => {
      await this.navegarAtras();
    });
  }

  volverLogin() {
    this._nav.navigateRoot('/auth', { replaceUrl: true });
  }

  volverInicio() {
    this._nav.navigateRoot('/app/inicio', { replaceUrl: true });
  }

  formularioLogin() {
    this._nav.navigateForward('/auth/login');
  }

  seleccionBaseDatos() {
    this._nav.navigateForward('/auth/seleccion-base');
  }

  irRecuperarPassword() {
    this._nav.navigateForward('/auth/pass-recovery');
  }

  navegarAdelante(ruta: string) {
    this._nav.navigateForward(`app/${ruta}`);
  }

  volverConRuta(ruta: string) {
    this._nav.navigateRoot(`app/${ruta}`, { replaceUrl: true });
  }

  volverSeleccionCliente() {
    this._nav.navigateRoot(`/seleccionar-cliente`, { replaceUrl: true });
  }

  async navegarAtras() {
    const url = this._router.url;
    const rutasBloqueadas = ['/auth', '/app/inicio', '/seleccionar-cliente'];
    const ahora = new Date().getTime();
    const isNative = Capacitor.isNativePlatform();

    if (rutasBloqueadas.includes(url)) {
      if (!isNative) return;
      if (ahora - this.lastTimeBackPress < this.timePeriodToExit) {
        App.exitApp();
      } else {
        this.lastTimeBackPress = ahora;
        await this._toast.exit();
      }
      return;
    }

    if (window.history.length > 1) {
      this._nav.back();
    } else {
      if (!isNative) return;
      if (ahora - this.lastTimeBackPress < this.timePeriodToExit) {
        App.exitApp();
      } else {
        this.lastTimeBackPress = ahora;
        await this._toast.exit();
      }
    }
  }
}
